import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'

import { withTranslation } from '~/i18n'
import { classNames } from '~/utils/string'
import styles from './index.module.scss'

const VoteIcon = ({
  positive, onClick, modifier, disabled, t
}) => {
  const title = t(positive ? 'upvote' : 'downvote')
  const className = classNames(styles.arrow, {
    [styles[modifier]]: modifier,
    [styles.disabled]: disabled,
  })

  return (
    <button
      type="button"
      title={title}
      aria-label={title}
      aria-pressed={modifier.startsWith('active')}
      onClick={() => onClick(positive)}
      disabled={disabled}
      className="btn p-0 m-0"
    >
      <FontAwesomeIcon
        size="2x"
        icon={positive ? faChevronUp : faChevronDown}
        className={className}
        fixedWidth
      />
    </button>
  )
}

VoteIcon.propTypes = {
  positive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  modifier: PropTypes.oneOf(['active-up', 'active-down', '']),
  disabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

VoteIcon.defaultProps = {
  modifier: '',
  disabled: false,
}

export default withTranslation('voteIcon')(VoteIcon)
